import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { UsageProvider } from "@/context/UsageContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Study from "@/pages/Study";
import Exercises from "@/pages/Exercises";
import Practice from "@/pages/Practice";
import Journal from "@/pages/Journal";
import LibraryPage from "@/pages/Library";
import PlanPage from "@/pages/Plan";
import OnboardingTour from "@/components/OnboardingTour";
import Admin from "@/pages/Admin";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppShell() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/app/admin"
        element={
          <Protected>
            <Admin />
          </Protected>
        }
      />
      <Route
        path="/app"
        element={
          <Protected>
            <>
              <Layout />
              <OnboardingTour />
            </>
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="study" element={<Study />} />
        <Route path="exercises" element={<Exercises />} />
        <Route path="practice" element={<Practice />} />
        <Route path="journal" element={<Journal />} />
        <Route path="library" element={<LibraryPage />} />
        <Route path="plan" element={<PlanPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LangProvider>
          <UsageProvider>
            <AppShell />
          </UsageProvider>
        </LangProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
